import { type AdSet } from "~/ui-rtk/api/types/paid-media.types"

interface AdSetItemProps {
  adSet: AdSet
  isSelected: boolean
  onToggle: () => void
  onShowCampaign: () => void
}

export default function AdSetItem({
  adSet,
  isSelected,
  onToggle,
  onShowCampaign,
}: AdSetItemProps) {
  return (
    <div className="flex items-center gap-3 p-3 bg-system-blue-800 rounded-lg border border-system-blue-600">
      <label className="flex items-center gap-3 cursor-pointer flex-1 min-w-0">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onToggle}
          className="w-4 h-4 rounded border-2 border-brand bg-system-blue-700 hover:border-system-blue-500 hover:bg-system-blue-600 checked:bg-brand checked:border-brand focus:ring-2 focus:ring-brand focus:ring-opacity-50 transition-colors duration-200 flex-shrink-0"
        />
        <div className="text-white font-medium truncate">{adSet.name}</div>
      </label>
      <button
        onClick={onShowCampaign}
        className="px-3 py-1 bg-system-blue-600 text-white text-xs rounded hover:bg-system-blue-500 transition-colors"
      >
        Show Campaign
      </button>
    </div>
  )
}
